export type TabId = 'basics' | 'location' | 'timeline' | 'docs' | 'review';

export const TAB_ORDER: TabId[] = ['basics', 'location', 'timeline', 'docs', 'review'];

/** Segment sizes for the weighted progress bar — proportional to how much data each tab carries. */
export const TAB_WEIGHTS: Record<TabId, number> = {
  basics: 32,
  location: 22,
  timeline: 26,
  docs: 12,
  review: 8,
};

/** Weighted 0–100 score from per-tab completion fractions (each 0..1, clamped). */
export function overallProgress(completion: Record<TabId, number>): number {
  const clamp = (n: number) => Math.min(1, Math.max(0, n));
  const score = TAB_ORDER.reduce((acc, id) => acc + TAB_WEIGHTS[id] * clamp(completion[id]), 0);
  return Math.round(score);
}
